import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.settings/view.scss */
:host {
  display: block;
  height: 100%;
}

.settings-page,
.settings-content,
.settings-main {
  min-width: 0;
  min-height: 0;
}

.settings-inner {
  min-width: 0;
}

.settings-inner input,
.settings-inner button {
  max-width: 100%;
}

.settings-inner .break-words {
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 767px) {
  .settings-page {
    overflow: hidden;
  }
  .settings-header {
    flex-wrap: wrap;
    align-items: flex-start !important;
    padding: 12px 14px !important;
  }
  .settings-header > span {
    font-size: 14px !important;
    line-height: 1.3;
  }
  .settings-header > button {
    width: 100%;
    min-height: 36px;
    justify-content: center;
  }
  .settings-content {
    flex-direction: column;
    overflow: hidden;
  }
  .settings-nav {
    width: 100% !important;
    flex: 0 0 auto !important;
    display: flex;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 8px 10px !important;
    border-right: 0 !important;
    border-bottom: 1px solid #e2e8f0;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .settings-nav::-webkit-scrollbar {
    display: none;
  }
  .settings-nav button {
    flex: 0 0 auto;
    width: auto !important;
    min-width: max-content;
    min-height: 34px;
    padding: 7px 12px !important;
    border-left-width: 0 !important;
    border-radius: 8px;
    text-align: center !important;
    white-space: nowrap;
  }
  .settings-main {
    width: 100%;
    flex: 1 1 auto;
    overflow-y: auto;
  }
  .settings-inner {
    max-width: none !important;
    padding: 14px 12px 18px !important;
  }
  .settings-inner .rounded-xl {
    border-radius: 10px !important;
  }
  .settings-inner .flex.items-start.justify-between,
  .settings-inner .flex.items-center.justify-between {
    flex-wrap: wrap;
  }
  .settings-inner .flex-shrink-0 {
    max-width: 100%;
  }
  .settings-inner button {
    white-space: normal;
  }
  .settings-footer {
    flex: 0 0 auto;
    gap: 8px !important;
    padding: 10px 12px max(10px, env(safe-area-inset-bottom)) !important;
  }
  .settings-footer button {
    flex: 1 1 0;
    min-width: 0;
    min-height: 38px;
  }
}`],
})
export class PageAdminSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public settings: any = {};
    public effectiveEngine: any = {};
    public enginePreflight: any = {};
    public loading: boolean = true;
    public saving: boolean = false;
    public activeSection: string = 'llm';
    public returnUrl: string = '/chatbot';
    public returnLabel: string = '검사로 돌아가기';
    public instructionUploadZipName: string = '';
    private readonly settingsReturnKey: string = 'inspection.settings.returnUrl';
    private readonly defaultOpenRouterModel: string = 'google/gemma-4-31b-it';
    private readonly defaultCodexModel: string = 'gpt-5.4';
    private readonly defaultOpenRouterRuntime: string = 'codex';
    private readonly legacyOpenRouterModels: string[] = ['gpt-5.5', 'openai/gpt-5.5', 'qwen/qwen3.6-27b'];
    private readonly legacyCodexModels: string[] = ['gpt-5.5', 'openai/gpt-5.5'];
    public sections: any[] = [
        { id: 'llm', label: '모델 설정' },
        { id: 'drive', label: '드라이브' },
        { id: 'instructionUpload', label: '지침 업로드' },
        { id: 'codex', label: '검사 엔진' },
        { id: 'design', label: '디자인' },
    ];
    public engineProviderOptions: any[] = [
        { value: 'gpt', label: 'GPT Codex' },
        { value: 'internal', label: '내부 API' },
        { value: 'openrouter', label: 'OpenRouter' },
        { value: 'ollama', label: 'Ollama' },
    ];
    public openRouterModelOptions: any[] = [
        { value: 'google/gemma-4-31b-it', label: 'Gemma 4 31B' },
    ];
    public reasoningOptions: any[] = [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: 'xhigh', label: 'XHigh' },
    ];
    public instructionPipelineSteps: string[] = [
        'ZIP 업로드',
        'HWP/HWPX 파일별 분해',
        '규칙 기반 목차 파싱',
        '장별 Markdown 변환',
        '이미지 저장 및 경로 치환',
        '경로 기반 instruction 생성',
    ];
    public themeOptions: any[] = [
        { value: 'modern', label: '모던', description: '현재 기본 디자인' },
        { value: 'retro', label: '레트로', description: '예전 관리 화면 스타일' },
    ];

    public async ngOnInit() {
        await this.service.init();
        this.resolveReturnUrl();
        await this.loadSettings();
        await this.service.render();
    }

    private safeInspectionUrl(url: any): string {
        const value = String(url || '').trim();
        if (!value || value.startsWith('//')) return '';
        if (value === '/chatbot' || value.startsWith('/chatbot/') || value.startsWith('/chatbot?') || value.startsWith('/chatbot#')) return value;
        return '';
    }

    private resolveReturnUrl() {
        let queryReturn = '';
        try {
            queryReturn = new URLSearchParams(location.search || '').get('return') || '';
        } catch (e) { }

        let storedReturn = '';
        try {
            storedReturn = sessionStorage.getItem(this.settingsReturnKey) || '';
        } catch (e) { }

        const safeUrl = this.safeInspectionUrl(queryReturn) || this.safeInspectionUrl(storedReturn) || '/chatbot';
        this.returnUrl = safeUrl;
        this.returnLabel = safeUrl.startsWith('/chatbot/room/') ? '이전 검사로 돌아가기' : '검사로 돌아가기';
    }

    public returnToInspection() {
        const target = this.safeInspectionUrl(this.returnUrl) || '/chatbot';
        try {
            sessionStorage.removeItem(this.settingsReturnKey);
        } catch (e) { }
        this.service.href(target);
    }

    public async loadSettings() {
        this.loading = true;
        await this.service.render();
        const res: any = await wiz.call('load');
        if (res.code === 200) {
            this.settings = res.data || {};
            this.effectiveEngine = this.settings.effective_inspection_engine || {};
            this.enginePreflight = this.settings.inspection_engine_preflight || {};
            delete this.settings.effective_inspection_engine;
            delete this.settings.inspection_engine_preflight;
            if (!this.settings.llm_provider) this.settings.llm_provider = 'ollama';
            if (this.settings.llm_provider !== 'ollama') this.settings.llm_provider = 'ollama';
            if (!this.settings.llm_ollama_base_url || this.settings.llm_ollama_base_url === 'http://127.0.0.1:11434') this.settings.llm_ollama_base_url = 'http://220.82.71.5:11434';
            if (!this.settings.llm_ollama_model || this.settings.llm_ollama_model === 'qwen3.6:35b-a3b') this.settings.llm_ollama_model = 'qwen3.5:27b';
            if (!this.settings.llm_ollama_model_light || this.settings.llm_ollama_model_light === 'qwen3:8b-q4_K_M') this.settings.llm_ollama_model_light = 'qwen3.5:9b';
            if (this.settings.llm_ollama_multimodal === undefined || this.settings.llm_ollama_multimodal === null) this.settings.llm_ollama_multimodal = true;
            if (!this.settings.llm_openrouter_base_url) this.settings.llm_openrouter_base_url = 'https://openrouter.ai/api/v1';
            if (!this.settings.llm_openrouter_model) this.settings.llm_openrouter_model = this.defaultOpenRouterModel;
            if (!this.settings.inspection_engine_openrouter_runtime) this.settings.inspection_engine_openrouter_runtime = this.defaultOpenRouterRuntime;
            this.normalizeEngineSettings();
            this.settings.inspection_engine_model = this.normalizeCodexModel(this.settings.inspection_engine_model);
            if (!this.settings.inspection_engine_reasoning_effort) {
                this.settings.inspection_engine_reasoning_effort = 'high';
            }
            if (!this.settings.inspection_engine_omission_reasoning_effort) {
                this.settings.inspection_engine_omission_reasoning_effort = 'high';
            }
            if (!['chapter', 'page'].includes(this.settings.codex_plan_split_mode)) {
                this.settings.codex_plan_split_mode = 'chapter';
            }
            if (!this.settings.codex_plan_batch_pages) this.settings.codex_plan_batch_pages = 10;
            if (!this.settings.codex_omission_batch_pages) this.settings.codex_omission_batch_pages = 8;
            this.normalizeCodexOmissionSettings();
            this.normalizeCodexCopyImageSettings();
            this.normalizeUiSettings();
            this.normalizeDriveVectorSettings();
            this.normalizeInstructionUploadSettings();
        }
        this.loading = false;
        await this.service.render();
    }

    public async saveSettings(silentSuccess: boolean = false): Promise<boolean> {
        this.normalizeEngineSettings();
        this.normalizeCodexOmissionSettings();
        this.normalizeCodexCopyImageSettings();
        this.normalizeUiSettings();
        this.normalizeDriveVectorSettings();
        this.normalizeInstructionUploadSettings();
        this.saving = true;
        await this.service.render();
        let alert: any = null;
        let saved = false;
        try {
            const provider = this.normalizeEngineProvider(this.settings.inspection_engine_provider);
            const res: any = await wiz.call('save', {
                settings: JSON.stringify(this.settings),
                inspection_engine_provider: provider,
                llm_openrouter_model: provider === 'openrouter' ? this.settings.llm_openrouter_model : '',
            });
            if (res.code === 200) {
                if (res.data && res.data.settings) {
                    this.settings = res.data.settings;
                    this.effectiveEngine = this.settings.effective_inspection_engine || this.effectiveEngine || {};
                    this.enginePreflight = this.settings.inspection_engine_preflight || this.enginePreflight || {};
                    delete this.settings.effective_inspection_engine;
                    delete this.settings.inspection_engine_preflight;
                    this.normalizeEngineSettings();
                    this.normalizeCodexOmissionSettings();
                    this.normalizeCodexCopyImageSettings();
                    this.normalizeUiSettings();
                    this.normalizeDriveVectorSettings();
                    this.normalizeInstructionUploadSettings();
                }
                if (res.data && res.data.effective_inspection_engine) {
                    this.effectiveEngine = res.data.effective_inspection_engine;
                }
                if (res.data && res.data.inspection_engine_preflight) {
                    this.enginePreflight = res.data.inspection_engine_preflight;
                }
                saved = true;
                const warning = res.data && res.data.warning ? String(res.data.warning) : '';
                const preflightWarning = this.enginePreflightMessage();
                const message = warning || (preflightWarning ? `설정은 저장되었습니다. ${preflightWarning}` : '설정이 저장되었습니다. 앞으로 시작하는 검사는 선택한 검사 엔진을 사용합니다.');
                alert = {
                    title: warning || preflightWarning ? '저장 완료 - 실행 전 확인 필요' : '저장 완료',
                    message,
                    action: '확인',
                    status: warning || preflightWarning ? 'warning' : 'success',
                    actionBtn: warning || preflightWarning ? 'warning' : 'success',
                    cancel: false,
                };
            } else {
                alert = {
                    title: '저장 실패',
                    message: this.responseMessage(res, '설정 저장에 실패했습니다.'),
                    action: '확인',
                    status: 'error',
                    actionBtn: 'error',
                    cancel: false,
                };
            }
        } catch (e) {
            alert = {
                title: '저장 실패',
                message: this.errorMessage(e, '설정 저장 중 오류가 발생했습니다.'),
                action: '확인',
                status: 'error',
                actionBtn: 'error',
                cancel: false,
            };
        }
        this.saving = false;
        await this.service.render();
        if (alert && (!silentSuccess || alert.status !== 'success')) {
            await this.service.modal.show(alert);
            await this.service.render();
        }
        return saved;
    }

    public toggle(key: string) {
        this.settings[key] = !this.settings[key];
        if (key === 'codex_omission_basic_title_only' && !this.settings[key]) {
            this.settings.codex_omission_basic_title_prefilter = false;
        }
        if (key === 'codex_omission_basic_title_prefilter' && !this.settings.codex_omission_basic_title_only) {
            this.settings.codex_omission_basic_title_prefilter = false;
        }
        this.service.render();
    }

    private normalizeTheme(value: any): string {
        return String(value || '').trim().toLowerCase() === 'retro' ? 'retro' : 'modern';
    }

    private storedTheme(): string {
        try {
            const raw = localStorage.getItem('ui-theme');
            return raw ? this.normalizeTheme(raw) : '';
        } catch (e) {
            return '';
        }
    }

    private applyTheme(value: any) {
        const theme = this.normalizeTheme(value);
        this.settings.ui_theme = theme;
        try {
            localStorage.setItem('ui-theme', theme);
            window.dispatchEvent(new StorageEvent('storage', { key: 'ui-theme', newValue: theme }));
        } catch (e) { }
    }

    public setTheme(value: string) {
        this.applyTheme(value);
        this.service.render();
    }

    private normalizeUiSettings() {
        const stored = this.storedTheme();
        const theme = stored || this.settings.ui_theme || 'modern';
        this.applyTheme(theme);
    }

    private normalizeDriveVectorSettings() {
        if (this.settings.copy_drive_vectordb_enabled === undefined || this.settings.copy_drive_vectordb_enabled === null) {
            this.settings.copy_drive_vectordb_enabled = true;
        }
        if (this.settings.copy_drive_vectordb_auto_index === undefined || this.settings.copy_drive_vectordb_auto_index === null) {
            this.settings.copy_drive_vectordb_auto_index = true;
        }
        if (!this.settings.copy_drive_vectordb_top_k) this.settings.copy_drive_vectordb_top_k = 8;
        if (!this.settings.copy_drive_similarity_threshold) this.settings.copy_drive_similarity_threshold = 0.8;
        if (this.settings.copy_use_image === undefined || this.settings.copy_use_image === null) this.settings.copy_use_image = true;
    }

    private settingMissing(key: string): boolean {
        return this.settings[key] === undefined || this.settings[key] === null || this.settings[key] === '';
    }

    private normalizeRelativePath(key: string, fallback: string) {
        const value = String(this.settings[key] || '').trim().replace(/\\/g, '/');
        const parts = value.split('/').filter((part: string) => part && part !== '.' && part !== '..');
        this.settings[key] = parts.join('/') || fallback;
    }

    private normalizeInstructionUploadSettings() {
        if (this.settings.instruction_upload_enabled === undefined || this.settings.instruction_upload_enabled === null) {
            this.settings.instruction_upload_enabled = true;
        }
        if (this.settings.instruction_upload_auto_extract_hwp === undefined || this.settings.instruction_upload_auto_extract_hwp === null) {
            this.settings.instruction_upload_auto_extract_hwp = true;
        }
        this.settings.instruction_upload_read_toc = true;
        this.settings.instruction_upload_split_mode = 'file_toc_chapter';
        if (this.settings.instruction_upload_auto_convert_md === undefined || this.settings.instruction_upload_auto_convert_md === null) {
            this.settings.instruction_upload_auto_convert_md = true;
        }
        if (this.settings.instruction_upload_auto_generate_instruction === undefined || this.settings.instruction_upload_auto_generate_instruction === null) {
            this.settings.instruction_upload_auto_generate_instruction = true;
        }
        if (this.settingMissing('instruction_upload_workspace_dir')) this.settings.instruction_upload_workspace_dir = 'data/instruction_uploads';
        if (this.settingMissing('instruction_upload_markdown_dir')) this.settings.instruction_upload_markdown_dir = 'data/instructions/generated';
        if (this.settingMissing('instruction_upload_image_dir')) this.settings.instruction_upload_image_dir = 'data/instructions/assets';
        if (this.settingMissing('instruction_upload_skill_dir')) this.settings.instruction_upload_skill_dir = 'data/.codex/.agent/skills';
        this.normalizeRelativePath('instruction_upload_workspace_dir', 'data/instruction_uploads');
        this.normalizeRelativePath('instruction_upload_markdown_dir', 'data/instructions/generated');
        this.normalizeRelativePath('instruction_upload_image_dir', 'data/instructions/assets');
        this.normalizeRelativePath('instruction_upload_skill_dir', 'data/.codex/.agent/skills');
    }

    private normalizeCodexOmissionSettings() {
        if (this.settings.codex_omission_basic_title_only === undefined || this.settings.codex_omission_basic_title_only === null) {
            this.settings.codex_omission_basic_title_only = true;
        }
        if (this.settings.codex_omission_basic_title_prefilter === undefined || this.settings.codex_omission_basic_title_prefilter === null) {
            this.settings.codex_omission_basic_title_prefilter = true;
        }
        const rowQuestionGroupSize = Number(this.settings.codex_omission_row_question_group_size);
        this.settings.codex_omission_row_question_group_size = Number.isFinite(rowQuestionGroupSize)
            ? Math.max(1, Math.min(Math.round(rowQuestionGroupSize), 12))
            : 8;
        if (!this.settings.codex_omission_basic_title_only) {
            this.settings.codex_omission_basic_title_prefilter = false;
        }
    }

    private normalizeCodexCopyImageSettings() {
        if (this.settings.codex_copy_image_llm_review_enabled === undefined || this.settings.codex_copy_image_llm_review_enabled === null) {
            this.settings.codex_copy_image_llm_review_enabled = false;
        }
        if (this.settings.codex_copy_image_neural_tool_enabled === undefined || this.settings.codex_copy_image_neural_tool_enabled === null) {
            this.settings.codex_copy_image_neural_tool_enabled = true;
        }
        if (!this.settings.codex_copy_image_neural_tool_url) this.settings.codex_copy_image_neural_tool_url = '';
        if (!this.settings.codex_copy_image_neural_tool_command) this.settings.codex_copy_image_neural_tool_command = '';
        const imageBackends = ['auto', 'openrouter', 'openrouter_embedding', 'openrouter-embedding', 'gemini_embedding', 'gemini-embedding', 'transformers', 'transformers_clip', 'clip', 'sentence_transformers', 'sentence-transformers'];
        const imageBackend = String(this.settings.codex_copy_image_neural_backend || '').trim();
        if (!imageBackend || !imageBackends.includes(imageBackend)) {
            this.settings.codex_copy_image_neural_backend = 'transformers_clip';
        }
        const imageModel = String(this.settings.codex_copy_image_neural_model || '').trim();
        const backendForModel = String(this.settings.codex_copy_image_neural_backend || '').trim();
        if (['openrouter', 'openrouter_embedding', 'openrouter-embedding', 'gemini_embedding', 'gemini-embedding'].includes(backendForModel) && !imageModel) {
            this.settings.codex_copy_image_neural_model = 'google/gemini-embedding-001';
        } else if (!imageModel) {
            this.settings.codex_copy_image_neural_model = 'openai/clip-vit-base-patch32';
        }
        if (!this.settings.codex_copy_image_neural_cache_dir) this.settings.codex_copy_image_neural_cache_dir = 'data/model-cache/copy-image-neural';
        if (!['auto', 'cpu', 'cuda'].includes(String(this.settings.codex_copy_image_neural_device || '').trim())) {
            this.settings.codex_copy_image_neural_device = 'auto';
        }
        const timeout = Number(this.settings.codex_copy_image_neural_tool_timeout_seconds || 120);
        this.settings.codex_copy_image_neural_tool_timeout_seconds = Math.max(10, Math.min(timeout || 120, 600));
        const batchSize = Number(this.settings.codex_copy_image_neural_batch_size || 16);
        this.settings.codex_copy_image_neural_batch_size = Math.max(1, Math.min(batchSize || 16, 64));
        const topK = Number(this.settings.codex_copy_image_neural_top_k || 5);
        this.settings.codex_copy_image_neural_top_k = Math.max(1, Math.min(topK || 5, 50));
        const threshold = Number(this.settings.codex_copy_image_neural_similarity_threshold || 0.92);
        this.settings.codex_copy_image_neural_similarity_threshold = Math.max(0.5, Math.min(threshold || 0.92, 1));
        const fullScanImageLimit = Number(this.settings.codex_copy_image_neural_full_scan_image_limit || 240);
        this.settings.codex_copy_image_neural_full_scan_image_limit = Math.max(20, Math.min(fullScanImageLimit || 240, 1000));
    }

    public clearEngineApiKey() {
        this.settings.inspection_engine_api_key = '';
        this.settings.inspection_engine_api_key_configured = false;
        this.service.render();
    }

    public setReasoningEffort(value: string) {
        this.settings.inspection_engine_reasoning_effort = value;
        this.service.render();
    }

    public setOmissionReasoningEffort(value: string) {
        this.settings.inspection_engine_omission_reasoning_effort = (
            this.settings.inspection_engine_provider === 'gpt' && value === 'low'
        ) ? 'high' : value;
        this.service.render();
    }

    public async onInstructionZipFileChange(event: any) {
        const input = event?.target;
        const file = input?.files && input.files.length ? input.files[0] : null;
        if (!file) {
            this.instructionUploadZipName = '';
            await this.service.render();
            return;
        }
        const name = String(file.name || '');
        if (!name.toLowerCase().endsWith('.zip')) {
            this.instructionUploadZipName = '';
            if (input) input.value = '';
            await this.service.modal.show({
                title: 'ZIP 파일만 업로드할 수 있습니다',
                message: '지침 문서 자동 분해 파이프라인은 ZIP 파일을 입력으로 사용합니다.',
                action: '확인',
                status: 'warning',
                actionBtn: 'warning',
                cancel: false,
            });
        } else {
            this.instructionUploadZipName = name;
        }
        await this.service.render();
    }

    public async showInstructionUploadPending() {
        await this.service.modal.show({
            title: '지침 업로드 준비 중',
            message: 'ZIP 분해, 규칙 기반 HWP/HWPX 목차 파싱, 파일별 장 분할, 이미지 경로 매핑, instruction 생성 엔진이 연결되면 이 설정을 기준으로 실행됩니다.',
            action: '확인',
            status: 'warning',
            actionBtn: 'warning',
            cancel: false,
        });
        await this.service.render();
    }

    public goInstructionManager() {
        this.service.href('/admin/instructions');
    }

    private normalizeEngineProvider(value: any): string {
        const provider = String(value || 'gpt').trim().toLowerCase();
        if (['gpt', 'openrouter', 'ollama', 'internal'].includes(provider)) return provider;
        return 'gpt';
    }

    private normalizeOpenRouterModel(value: any): string {
        const model = String(value || '').trim();
        if (!model || this.legacyOpenRouterModels.includes(model.toLowerCase())) {
            return this.defaultOpenRouterModel;
        }
        return model;
    }

    private normalizeCodexModel(value: any): string {
        const model = String(value || '').trim();
        if (!model || this.legacyCodexModels.includes(model.toLowerCase())) {
            return this.defaultCodexModel;
        }
        return model;
    }

    private normalizeOpenRouterRuntime(value: any): string {
        return this.defaultOpenRouterRuntime;
    }

    private syncEngineProviderFlags() {
        const provider = this.normalizeEngineProvider(this.settings.inspection_engine_provider);
        this.settings.inspection_engine_provider = provider;
        this.settings.inspection_engine_use_ollama = provider === 'ollama';
        this.settings.inspection_engine_use_internal_api = provider === 'internal';
    }

    private normalizeEngineSettings() {
        this.syncEngineProviderFlags();
        if (!this.settings.llm_ollama_base_url) this.settings.llm_ollama_base_url = 'http://220.82.71.5:11434';
        if (!this.settings.llm_ollama_model) this.settings.llm_ollama_model = 'qwen3.5:27b';
        if (!this.settings.llm_ollama_model_light) this.settings.llm_ollama_model_light = 'qwen3.5:9b';
        if (!this.settings.llm_openrouter_base_url) this.settings.llm_openrouter_base_url = 'https://openrouter.ai/api/v1';
        this.settings.inspection_engine_openrouter_runtime = this.normalizeOpenRouterRuntime(this.settings.inspection_engine_openrouter_runtime);
        if (this.settings.inspection_engine_provider === 'openrouter') {
            this.settings.llm_openrouter_model = this.normalizeOpenRouterModel(this.settings.llm_openrouter_model);
        } else if (!this.settings.llm_openrouter_model) {
            this.settings.llm_openrouter_model = this.defaultOpenRouterModel;
        }
        this.settings.inspection_engine_model = this.normalizeCodexModel(this.settings.inspection_engine_model);
        if (!this.settings.inspection_engine_reasoning_effort) this.settings.inspection_engine_reasoning_effort = 'high';
        if (!this.settings.inspection_engine_omission_reasoning_effort) this.settings.inspection_engine_omission_reasoning_effort = 'high';
        if (this.settings.inspection_engine_provider === 'gpt' && this.settings.inspection_engine_omission_reasoning_effort === 'low') {
            this.settings.inspection_engine_omission_reasoning_effort = 'high';
        }
        if (!this.settings.inspection_engine_provider_name) this.settings.inspection_engine_provider_name = 'AutoCheck Internal';
    }

    public async setEngineProvider(value: string) {
        if (this.saving) return;
        this.settings.inspection_engine_provider = this.normalizeEngineProvider(value);
        if (this.settings.inspection_engine_provider === 'openrouter') {
            this.settings.llm_openrouter_model = this.normalizeOpenRouterModel(this.settings.llm_openrouter_model);
            this.settings.inspection_engine_openrouter_runtime = this.defaultOpenRouterRuntime;
        }
        this.normalizeEngineSettings();
        this.enginePreflight = {};
        await this.service.render();
        await this.saveSettings(true);
    }

    public async setOpenRouterModel(value: string) {
        if (this.saving) return;
        this.settings.llm_openrouter_model = this.normalizeOpenRouterModel(value);
        this.normalizeEngineSettings();
        this.enginePreflight = {};
        await this.service.render();
    }

    public isOpenRouterModelSelected(value: string): boolean {
        return this.normalizeOpenRouterModel(this.settings.llm_openrouter_model) === value;
    }

    public showReasoningControls(): boolean {
        const provider = this.normalizeEngineProvider(this.settings.inspection_engine_provider);
        return provider !== 'ollama';
    }

    private openRouterRuntimeLabel(value: any): string {
        return 'Codex SDK';
    }

    private engineLabel(config: any): string {
        const provider = String(config?.provider || 'ollama');
        const effectiveProvider = String(config?.effective_provider || '').trim().toLowerCase();
        const model = String(config?.model || '');
        if (provider === 'ollama') {
            const host = String(config?.ollama_host || this.settings.llm_ollama_base_url || '');
            return `Ollama ${model || this.settings.llm_ollama_model || 'qwen3.5:27b'}${host ? ' · ' + host : ''}`;
        }
        let label = provider === 'internal' ? String(config?.internal_provider_name || '내부 API') : 'GPT Codex';
        const openRouterRuntime = this.normalizeOpenRouterRuntime(config?.openrouter_runtime || this.settings.inspection_engine_openrouter_runtime);
        if (provider === 'openrouter' || effectiveProvider === 'openrouter') {
            label = `OpenRouter · ${this.openRouterRuntimeLabel(openRouterRuntime)}`;
        }
        const effort = String(config?.reasoning_effort || this.settings.inspection_engine_reasoning_effort || '');
        const omissionEffort = String(config?.omission_reasoning_effort || this.settings.inspection_engine_omission_reasoning_effort || '');
        const omissionLabel = omissionEffort && omissionEffort !== effort ? ` · omission ${omissionEffort}` : '';
        const fallbackModel = provider === 'openrouter' || effectiveProvider === 'openrouter' ? this.normalizeOpenRouterModel(this.settings.llm_openrouter_model) : this.normalizeCodexModel(this.settings.inspection_engine_model);
        return `${label} ${model || fallbackModel}${effort ? ' · reasoning ' + effort : ''}${omissionLabel}`;
    }

    public effectiveEngineLabel(): string {
        return this.engineLabel(this.effectiveEngine || {});
    }

    public selectedEngineLabel(): string {
        const provider = this.normalizeEngineProvider(this.settings.inspection_engine_provider);
        const openRouterRuntime = this.normalizeOpenRouterRuntime(this.settings.inspection_engine_openrouter_runtime);
        const usesReasoning = provider !== 'ollama';
        return this.engineLabel({
            provider,
            model: provider === 'ollama' ? this.settings.llm_ollama_model : (provider === 'openrouter' ? this.normalizeOpenRouterModel(this.settings.llm_openrouter_model) : this.settings.inspection_engine_model),
            reasoning_effort: usesReasoning ? this.settings.inspection_engine_reasoning_effort : '',
            omission_reasoning_effort: usesReasoning ? this.settings.inspection_engine_omission_reasoning_effort : '',
            ollama_host: this.settings.llm_ollama_base_url,
            internal_provider_name: this.settings.inspection_engine_provider_name,
            openrouter_runtime: openRouterRuntime,
        });
    }

    public enginePreflightMessage(): string {
        const provider = this.normalizeEngineProvider(this.settings.inspection_engine_provider);
        if (provider === 'internal') {
            const baseUrl = String(this.settings.inspection_engine_api_base_url || '').trim();
            const key = String(this.settings.inspection_engine_api_key || '').trim();
            const hasKey = !!this.settings.inspection_engine_api_key_configured || (!!key && key !== '********');
            if (!baseUrl) return '내부 API Base URL이 없습니다. Base URL을 입력한 뒤 저장해주세요.';
            if (!hasKey) return '내부 API Key가 없습니다. API Key를 입력한 뒤 저장해주세요.';
        }
        if (provider === 'openrouter') {
            if (!String(this.settings.llm_openrouter_base_url || '').trim()) return 'OpenRouter Base URL이 없습니다. Base URL을 입력한 뒤 저장해주세요.';
            if (!String(this.settings.llm_openrouter_model || '').trim()) return 'OpenRouter 모델 ID가 없습니다. 모델 ID를 입력한 뒤 저장해주세요.';
        }
        if (!this.enginePreflight || this.enginePreflight.ok !== false) return '';
        const checkedProvider = String(this.enginePreflight.provider || '').trim().toLowerCase();
        if (checkedProvider && checkedProvider !== provider) return '';
        return String(this.enginePreflight.message || '검사 엔진 준비 상태를 확인해주세요.');
    }

    private responseMessage(res: any, fallback: string): string {
        return String(res?.data?.message || res?.message || fallback);
    }

    private errorMessage(error: any, fallback: string): string {
        return String(error?.message || error?.data?.message || error || fallback);
    }

    public async setSection(section: string) {
        this.activeSection = section;
        await this.service.render();
    }

}

export default PageAdminSettingsComponent;